import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '@govtechsg/sgds-react/Button'
//import { Footer } from '@govtechsg/sgds-react'
import { Helmet } from "react-helmet-async";
import { CopyBlock , a11yLight, github} from 'react-code-blocks';

// Components
import HeaderRegComponent from '../../Components/HeaderRegComponent'
import FooterComponent from '../../Components/FooterComponent'
import workshopImage from '../../images/blog/workshop_sep_2025.jpeg'; // We'll use the same image for now
import formlinkImage from '../../images/blog/gogovsg_link.png';

import  onemapPresentation1 from '../../images/blog/OneMap_API_Workshop_Demo_260825.pdf';
import  onemapPresentation2 from '../../images/blog/OneMap_API_Workshop_Presentation_260825.pdf';

const WorkshopAug2025 = () => {
  	return (
		<>
		<Helmet>
        <title>OneMap Workshop – August 2025| OneMap API</title>
        <meta
          name="description"
          content="OneMap Workshop August 2025, Adapting Geospatial Technologies into Meaningful Features"
        />
      </Helmet>
		<div className="om-body container-fluid">

			<HeaderRegComponent />

			<div className="om-body-content pageBase">
                <div className='blog center om-body-container'>
                    <div className='row mb-4'>
                        <div class="col-md-10 offset-md-1">

                        <img className="img-fluid w-100" src={workshopImage} alt='intro' />
                        <h2 style={{marginTop: "30px"}}>Adapting Geospatial Technologies into Meaningful Features</h2>
                        <p>Singapore Land Authority conducted another successful iteration of the OneMap Workshop in August 2025 at the SLA office, drawing together a diverse mix of audiences: ranging from officers from various government agencies and statutory boards; professionals from private sectors looking to tap into the OneMap platform resources, and eager learners of what OneMap and its suite of APIs can benefit them.</p>

                        <h2>Purpose of the Workshop</h2>
                        <p>This workshop session, co-led by Justin and Shiva from SLA, introduces an updated lineup of features available on OneMap; use cases by various agencies tapping on the OneMap APIs; and also a hands-on demonstration on updating search APIs with token-based authentication, and some API use cases.</p>

                        <h2>Key Highlights</h2>
                        
                        <h3>Introduction to OneMap's Features and Services</h3>
                        <p>This session introduced to the audiences the wide range of thematic layers accessible to both government and public, such as query services and routing capabilities. The Barrier-Free Access (BFA) routing capability made available on OneMap, part of the SG-Enabling Masterplan 2030, was also showcased during the workshop.</p>

                        <h3>OneMap API Use Cases</h3>
                        <p>Various applications in both public and private spheres deploying OneMap services via API were also presented during the workshop. Up to 90 over such apps and services employed OneMap in their usage.</p>

                        <h3>OneMap API Updates</h3>
                        <p>OneMap's Search API Tokenized Search is a recent update that most API users will start to observe when accessing the OneMap website. Once adopted, users will receive a unique authentication token for their queries, which will be renewed every 3 days. This approach will be beneficial down the road, allowing OneMap and their users to better align their usage and services for better communication.</p>
                        
                        <ul>
                            <li><b>Registration for Search API Token</b></li>
                            <li><b>Token Management & Verification</b></li>
                            <li><b>Live Demonstration on Search APIs</b></li>
                        </ul>

                        <p>Users onboard the token-based authentication will have a higher API call limit capped at 250; and further request for higher limits can be discussed on a case-by-case basis.</p>

                        <p>Interested parties can contact the SLA team at <a href="mailto:onemap@sla.gov.sg">onemap@sla.gov.sg</a>, and include the following details to allow us to better assist you:</p>
                        <ul>
                            <li>Name of Application</li>
                            <li>Endpoints used</li>
                            <li>Expected Traffic</li>
                        </ul>

                        <h2>Connect with OneMap</h2>
                        <p>For those looking to implement OneMap in their own systems, our team is here to help. We encourage developers and data teams to reach out to us for:</p>
                        <ul>
                            <li><b>Technical guidance and support</b> on integrating OneMap APIs</li>
                            <li><b>Best practices and consultation</b> on applying geospatial intelligence in your business use case.</li>
                        </ul>

                        <p>You can find the slides from the workshop below:</p>
                        <a href="OneMap_API_Workshop_Demo_260825.pdf"></a>
                        <a href="OneMap_API_Workshop_Presentation_260825.pdf"></a>
                        <a href={onemapPresentation1}>OneMap_API_Workshop_Demo_260825.pdf</a><br/>
                        <a href={onemapPresentation2}>OneMap_API_Workshop_Presentation_260825.pdf</a>

                        <div style={{marginBottom:"7em"}}/>
 
                    </div>
                </div>
            </div>
        </div>

			<FooterComponent />

		</div>
		</>
	)
}

export default WorkshopAug2025